import { errorHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { AccountPath, getAccountUrl, getPartnerUrl } from 'urlBuilder';

export const getExternalSsoAppUrl = (app: domain.SsoLoginApplication) => {
    switch (app) {
        case domain.SsoLoginApplication.Account:
            return getAccountUrl(AccountPath.root);

        case domain.SsoLoginApplication.Partner:
            return getPartnerUrl();

        default:
            throw errorHelpers.assertNever(app);
    }
};
